import { render, staticRenderFns } from "./StatusView.vue?vue&type=template&id=2835afb0&scoped=true"
import script from "./StatusView.vue?vue&type=script&lang=js"
export * from "./StatusView.vue?vue&type=script&lang=js"
import style0 from "./StatusView.vue?vue&type=style&index=0&id=2835afb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2835afb0",
  null
  
)

export default component.exports